
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFA329"}},[_c('path',{attrs:{"d":"M2.5 23.999a2.503 2.503 0 01-2.5-2.5v-19c0-1.379 1.121-2.5 2.5-2.5h19c1.378 0 2.5 1.121 2.5 2.5v19c0 1.378-1.122 2.5-2.5 2.5h-19zm0-23c-.827 0-1.5.673-1.5 1.5v19c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-19c0-.827-.673-1.5-1.5-1.5h-19z"}}),_c('path',{attrs:{"d":"M6.5 9.499a.5.5 0 01-.354-.146l-1.5-1.5A.5.5 0 015 6.999a.5.5 0 01.354.146L6.5 8.292l3.646-3.646a.5.5 0 11.708.707l-4 4a.5.5 0 01-.354.146zM6.5 19.499a.5.5 0 01-.354-.146l-1.5-1.5A.5.5 0 015 16.999a.5.5 0 01.354.146L6.5 18.292l3.646-3.646a.5.5 0 11.708.707l-4 4a.5.5 0 01-.354.146zM13.5 8.999a.5.5 0 010-1h6a.5.5 0 010 1h-6zM13.5 17.999a.5.5 0 010-1h6a.5.5 0 010 1h-6z"}})])])
          )
        }
      }
    